import React, { useEffect, useRef } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  max-width: 900px;

  .inner {
    display: block;
  }
`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
const StyledPic = styled.div`
  max-width: 280px;
  margin: 50px auto 0;
  text-align: center;

  .wrapper {
    display: block;
    width: 100%;

    .img {
      border-radius: var(--border-radius);
      width: 100%;
      height: auto;
    }
  }
`;

const About = () => {
  const data = useStaticQuery(graphql`
    query {
      avatar: file(relativePath: { eq: "me.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 280, placeholder: BLURRED, formats: [AUTO, WEBP])
        }
      }
    }
  `);

  const image = getImage(data.avatar);
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>
              Hi, I'm Vincent. Some people know me as that guy with the interesting business
              background between tech gigs. These days, I'm a dad of two boys. Their weekend Grab
              driver (but for free), Lego construction supervisor, and the guy who makes up bedtime
              stories because I'm too lazy to read the actual books.
            </p>
            <p>
              While the boys run to their mom for homework help (because let's be honest, she's way
              more patient and capable than me), they come to me for the fun shit - building
              ridiculous Lego army base and figuring out why their robot doesn't work.
            </p>
            <p>
              <b>I'm good at…</b>
              <ul>
                <li>Making technical stuff less painful</li>
                <li>
                  Parenting by being the fun parent (sorry dear, someone has to be the
                  disciplinarian){' '}
                </li>
              </ul>
            </p>
            <p>
              <b>I love…</b>
              <ul>
                <li>Productivity hacks that actually work (not the bullshit ones)</li>
                <li>
                  Technical toys that serve no purpose except being cool (only those that I can
                  afford)
                </li>
                <li>Minimalism (except for Lego - that shit is everywhere)</li>
                <li>Batman (he has lots of cool toys and he's rich…)</li>
                <li>Masked Rider (don't judge, it's quality entertainment)</li>
                <li>Cats (they're like minimalist pets - low maintenance, high attitude)</li>
              </ul>
            </p>
            <p>
              Bottom line: I solve problems, build stuff, and try not to screw up my kids too badly.
              So far, so good.
            </p>
          </div>
        </StyledText>

        <StyledPic>
          <div className="wrapper">
            <GatsbyImage className="img" image={image} alt="Headshot" />
          </div>
        </StyledPic>
      </div>
    </StyledAboutSection>
  );
};

export default About;
